import React, {Component, useMemo, useRef, useState} from 'react'
import {Grid, TextField, Link, InputAdornment, Tooltip} from '@material-ui/core';
import {Objects, Parts, Types} from "../index";
import API from "@beardeddevops/react.api"
import {LineChart} from "react-chartkick";
import 'chart.js'
import moment from "moment-timezone";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Button, ButtonGroup, Modal, ModalBody} from "reactstrap";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import StaticDispatchMap from "components/Parts/StaticDispatchMap"
import OptimizationsViewer from "../Parts/OptimizationsViewer";
import DayLayout from "../Parts/DayLayout";


function returnSymbol(color, scheduled) {

	const squareSymbol = {
		path: "M -2 -2 L 2 -2 L 2 2 L -2 2 z",
		strokeColor: color,
		fillColor: color,
		fillOpacity: 1,
	}

	const circleSymbol = {
		path: "M 0 1.75 z m 0 0.25 A 2 2 90 1 0 0 -2 a 2 2 90 0 0 0 4 z",
		strokeColor: color,
		fillColor: color,
		fillOpacity: 1,
	}

	const plusSymbol = {
		path: "M 0 -2.625 h 0.375 v 2.25 h 2.25 v 0.75 h -2.25 v 2.25 h -0.75 v -2.25 h -2.25 v -0.75 h 2.25 v -2.25 z",
		strokeColor: color,
		fillColor: color,
		fillOpacity: 1,
	}

	const starSymbol = {
		path: "M -1.2835 1.7125 c -0.0195 0.111 0.09 0.1978 0.1865 0.1482 l 1.0975 -0.564 l 1.0973 0.564 c 0.0965 0.0495 0.206 -0.0372 0.1865 -0.148 l -0.2075 -1.1825 l 0.8805 -0.839 c 0.0825 -0.0785 0.04 -0.222 -0.0705 -0.2375 l -1.2245 -0.174 L 0.1163 -1.802 a 0.1283 0.1283 90 0 0 -0.2318 0 L -0.6615 -0.72 l -1.2245 0.174 c -0.1103 0.0155 -0.153 0.159 -0.0707 0.2375 l 0.8808 0.839 l -0.2075 1.1825 z",
		strokeColor: color,
		fillColor: color,
		fillOpacity: 1,
	}

	const triangleSymbol = {
		path: "M -0.0155 -1.996 A 0.0325 0.0325 90 0 1 0.0005 -2 a 0.0325 0.0325 90 0 1 0.0158 0.004 a 0.0365 0.0365 90 0 1 0.0135 0.0143 l 1.7143 2.9167 c 0.009 0.015 0.0088 0.031 0.0005 0.0457 a 0.0408 0.0408 90 0 1 -0.0135 0.015 a 0.029 0.029 90 0 1 -0.0165 0.0043 H -1.7135 a 0.0288 0.0288 90 0 1 -0.0165 -0.0043 a 0.0408 0.0408 90 0 1 -0.0135 -0.015 a 0.044 0.044 90 0 1 0.0005 -0.0457 L -0.029 -1.9817 a 0.0367 0.0367 90 0 1 0.0135 -0.0143 z",
		strokeColor: color,
		fillColor: color,
		fillOpacity: 1,
	}

	const symbols = [
		circleSymbol,
		plusSymbol,
		triangleSymbol,
		squareSymbol,
		starSymbol
	]

	return symbols[scheduled];
}

function SymbolIcon({color, scheduled}) {
	const symbol = returnSymbol(color, scheduled);
	if (!symbol) return null;

	return (
		<svg width={20} height={20} viewBox="-5 -5 10 10">
			<path
				d={symbol.path}
				stroke={symbol.strokeColor}
				fill={symbol.fillColor}
				fillOpacity={symbol.fillOpacity}
			/>
		</svg>
	);
}

export default class ScheduleOptimizations extends Component {

	constructor(props) {
		super(props)
		this.state = {
			filterDate: moment().add(1, 'day').format('YYYY-MM-DD'),
			filterUsers: [],
			data: [],
			loading: false,
			showDate: false,
			regions: [],
			userColors: [],
			flaggedAppts: [],
			optimizations: [],
			optimization_index: 0
		}

	}

	async componentDidMount() {
		await this.getRegions();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.filterDate !== this.state.filterDate) {
			if (this.fetchTimeout) {
				clearTimeout(this.fetchTimeout);
			}

			this.fetchTimeout = setTimeout(() => {
				this.fetchFlags().then(() => {
					this.setState({ loading: false });
				});
			}, 300);
		}
	}

	getRegions = async () => {
		let regionModel = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		regionModel.limit = 100;
		try {
			this.regions = await regionModel.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				//Todo maybe filter by ranking instead
				return a.name.localeCompare(b.name)
			});
			this.regions = this.regions.filter((item) => {
				return item.metro_walk_ranking !== null && item.metro_walk_ranking !== undefined
			})
			this.setState({
				regions: this.regions,
			});
		} catch (error) {
			console.log('error', error)
		}
	}

	getEngineers = async () => {
		return [];
	}


	handleDateChange = async (name, date) => {
		this.setState({filterDate: moment(date).format('YYYY-MM-DD'), showDate: false})
	}

	fetchFlags = async () => {
		this.setState({loading: true})
		if (!this.state.filterDate || !this.state.selectedRegion || this.state.isOptimizing) {
			return;
		}
		let model = new API.BuildClass(Types.Calendar._name, API.RequestType.READ);
		model.filter = {
			'filterDate': this.state.filterDate,
			'filterRegion': this.state.selectedRegion.value
		}
		const data = await model.submit(null, 'GET_FLAGS');
		const arrayed = Object.values(data.items);
		//foreach flags and look for people that have flagged appts
		const flaggedAppts = [];
		await Promise.all(arrayed.map((item) => {
			if (item && item.appointments && item.appointments.length > 0) {
				item.appointments.filter((appt) => appt.flags.length > 0).map((flaggedAppt) => flaggedAppts.push(flaggedAppt))
			}
		}))
		this.setState({flaggedAppts, loading: false})
	}

	fetchOptimizations = async () => {
		if (!this.state.filterDate || !this.state.selectedRegion || this.state.isOptimizing) {
			return;
		}
		this.setState({isOptimizing: true, loading: true})
		let model = new API.BuildClass(Types.Calendar._name, API.RequestType.READ);
		model.filter = {
			'filterDate': this.state.filterDate,
			'filterRegion': this.state.selectedRegion.value
		}
		try {
			const data = await model.submit(null, 'GET_OPTIMIZE');
			this.setState({loading: false, isOptimizing: false, optimizations: data.items})
			if (data.items.length === 0) {
				API.Toast.warning('No possible schedules were found with a lower time than the current schedule.', {
					position: API.Toast.POSITION.TOP_CENTER
				});
			}
		} catch {
			this.setState({loading: false, isOptimizing: false, optimizations: [], optimization_index: 0})
		}
	}

	render() {

		const {showDate, flaggedAppts, filterDate, userColors, loading, isOptimizing, optimizations} = this.state;

		return (
			<div className={'form-group'}>
				{loading && <div
					style={{
						position: 'absolute', // position relative to nearest positioned ancestor (or body)
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)', // shift div back by 50% of its width/height
						padding: '20px',
						border: '1px solid black',
						borderRadius: '8px',
						zIndex: 9999, // ensures it appears above other elements
					}}
				>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</div>}
				<Modal
					isOpen={showDate}
					toggle={() => this.setState({showDate: !showDate})}
					size={"sm"}
					backdrop={true}
					style={{display: "none"}}
				>
					<ModalBody>
						<Framework.Elements.Date
							label={"Custom Date"}
							value={filterDate}
							update={this.handleDateChange}
							open={showDate}
							clearable={false}
							cancelLabel={''}
						/>
					</ModalBody>
				</Modal>
				<div className={"row rbc-toolbar"}>
					<div>
						<IconButton
							disabled={this.state.filterDate === moment().add(1, 'day').format('YYYY-MM-DD')}
							onClick={async () => {
								if (this.state.isOptimizing) {
									return;
								}
								this.setState({filterDate: moment(filterDate).subtract(1, 'day').format('YYYY-MM-DD'), optimizations: [], optimization_index: 0})
							}}><LeftArrowIcon/></IconButton>
						<button className="rbc-today" type="button" onClick={async () => {
							if (this.state.isOptimizing) {
								return;
							}
							this.setState({filterDate: moment().add(1, 'day').format('YYYY-MM-DD'), optimizations: [], optimization_index: 0})
						}}>Tomorrow
						</button>
						<IconButton onClick={async () => {
							if (this.state.isOptimizing) {
								return;
							}
							this.setState({filterDate: moment(filterDate).add(1, 'day').format('YYYY-MM-DD'), optimizations: [], optimization_index: 0})
						}}><RightArrowIcon/></IconButton>
					</div>
					<div className={"rbc-toolbar-label"}>
						<label onClick={() => {
							if (this.state.isOptimizing) {
								return;
							}
							this.setState({showDate: true})
						}}>
							{moment(filterDate).format('dddd MMM D')}
						</label>
					</div>
					<div style={{width: "35rem"}}>
						<Parts.RegionSelectToggle
							parent={this}
							handleRegionsCallback={async () => {
								if (this.state.isOptimizing) {
									return;
								}
								let selectedRegion = this.state.regions.filter(region => {
									return region.pkey === (this.state.filterRegion)
								})[0];
								await this.setState({
									optimizations: [], optimization_index: 0,
									selectedRegion: {value: selectedRegion.pkey, label: selectedRegion.name},
									field_engineers: []
								});
								await this.getEngineers();
								await this.fetchFlags();
							}}
							multi={false}
							noCycle={false}
						/>
					</div>
					<button className="rbc-today" style={{marginRight: 5, marginLeft: 10}} type="button" onClick={async () => {
						this.setState({loading: true})
						await this.fetchFlags();
					}}>Refresh
					</button>
					{/*<Tooltip title={flaggedAppts.length <= 0 ? "Can only optimize days that have flags." : ""}>*/}
						<Button className="rbc-today" style={{marginRight: 10, marginLeft: 5}}
							//disabled={flaggedAppts.length <= 0}
							    disabled={isOptimizing}
							    onClick={async () => {
								    this.setState({loading: true})
								    await this.fetchOptimizations();
								    this.setState({loading: false})
							    }}>Optimize
						</Button>
					{/*</Tooltip>*/}
				</div>

				{isOptimizing && <b>CURRENTLY OPTIMIZING - THIS MAY TAKE SEVERAL MINUTES</b>}

				<div className="row">
					<div className="col-6" key={userColors + flaggedAppts}>
						<b>Flagged Appointments</b>
						{/** Group appointments by FE */}
						{Object.entries(
							flaggedAppts.reduce((acc, item) => {
								if (!acc[item.fe]) acc[item.fe] = [];
								acc[item.fe].push(item);
								return acc;
							}, {})
						).map(([fe, appts]) => (
							<div key={fe} style={{paddingTop: 5}}>
								<b style={{color: userColors[fe] ?? 'black'}}>
									{appts[0].fe_name}
								</b>
								<div style={{marginLeft: 20}}>
									{appts.map((item) => (
										<div key={item.pkey} className="d-flex gap-2">
											<span>
												{<SymbolIcon color={userColors[fe] ?? 'black'} scheduled={item.appointmentsScheduled}/>}
												<b>{item.slot}:</b>
												{item.flags.join(', ')}
											</span>
										</div>
									))}
								</div>
							</div>
						))}
					</div>
				</div>

				<div className={'row'} style={{paddingTop: 10}}>
					{this.state.selectedRegion &&
						<div className={'col-6'} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
							<b style={{marginBottom: 48}}>Current Map</b>
							<Objects.DispatchMap
								filterRegion={this.state.selectedRegion.value}
								filterDate={this.state.filterDate}
								setColors={(userColors) => {
									this.setState({userColors})
								}}
								noCycle={true}
								onlyMap={true}
								noRefresh={true}
							/>
						</div>}
					{optimizations && optimizations.length > 0 &&
						<OptimizationsViewer
							optimizations={optimizations}
							userColors={this.state.userColors}
							region={this.state.regions.find((item) => item.pkey === this.state.selectedRegion.value)}
							setIndex={(index) => this.setState({optimization_index: index})}
						/>
						}
				</div>

				{optimizations && optimizations.length > 0 && <div className={'row'} style={{justifyContent: 'center'}}>
					<b style={{fontSize: 20}}>Optimized Schedule for Option {this.state.optimization_index + 1}</b>
					<div className={'col-12'}>
						<DayLayout scheduleData={optimizations[this.state.optimization_index].schedule}/>
					</div>
				</div>}

			</div>
		)
	};

};
